import { memo } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import { sessionStore } from '@/utils/storage'
import BasicStep from '../BasicStep/BasicStep'
const CONTENT: any = { 1: '开题正文', 2: '综述正文', 3: '论文正文', 4: '论文正文' }
const LunWenStep = ({ history, step }: any) => {
  const { id } = useParams() as any
  const LIST = [
    { label: '基本信息' },
    { label: id == 1 ? '阶段计划' : '摘要' },
    { label: '参考文献' },
    { label: '目录大纲' },
    { label: CONTENT[id] }
  ]
  const onConfirm = (step: number) => {
    console.log(step, 999)
    const cacheData = sessionStore.get('stepData', {}) as any
    if (step == 1) {
      cacheData.steps = cacheData.steps.slice(0, 1)
      const url = '/thesisTopic/' + id
      cacheData.pathname = url
      sessionStore.set('stepData', cacheData)
      history.push(url)
    }
    if (step == 2) {
      cacheData.steps = cacheData.steps.slice(0, 2)
      const url = id == 1 ? '/plans/' + id : '/major/' + id
      cacheData.pathname = url
      sessionStore.set('stepData', cacheData)
      history.push(url)
    }
    if (step == 3) {
      cacheData.steps = cacheData.steps.slice(0, 3)
      const url = '/references/' + id
      cacheData.pathname = url
      sessionStore.set('stepData', cacheData)
      history.push(url)
    }
  }
  return <BasicStep list={LIST} step={step} isGradient={false} onConfirm={onConfirm} />
}

export default memo(withRouter(LunWenStep))
